import CompanyBanner from "./CompanyBanner";
import CompanyNavBar from "./CompanyNavBar";
import CultureSectionComponent from "./CultureSection";
import OverviewSectionComponent from "./OverviewSection";
import PlatformSectionComponent from "./PlatformSection";
import ProductAdvantage from "./ProductAdvantage";
import QualificationSectionComponent from "./QualificationSection";
import ServicesSectionComponent from "./ServicesSection";
import TechnologySectionComponent from "./TechnologySection";

export default function Company() {
  return (
    <>
      <CompanyBanner>
        <p>开放 合作共赢 可持续</p>
        <p>Openness, win-win cooperation and sustainable development</p>
      </CompanyBanner>
      <CompanyNavBar />
      <OverviewSectionComponent />
      <CultureSectionComponent />
      <ServicesSectionComponent />
      <QualificationSectionComponent />
      <PlatformSectionComponent />
      <TechnologySectionComponent />
      <ProductAdvantage />
      {/* <ContactSectionComponent /> */}
    </>
  );
}
